export const getDealerPhoneNumber = (dealer) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const person = (_a = dealer === null || dealer === void 0 ? void 0 : dealer.dealerPersons) === null || _a === void 0 ? void 0 : _a[0];
    const firstname = person === null || person === void 0 ? void 0 : person.firstname;
    const lastname = person === null || person === void 0 ? void 0 : person.lastname;
    const phoneNumber = (_b = person === null || person === void 0 ? void 0 : person.phone) === null || _b === void 0 ? void 0 : _b.number;
    if (lastname && firstname && phoneNumber) {
        return phoneNumber;
    }
    if ((_e = (_d = (_c = dealer === null || dealer === void 0 ? void 0 : dealer.additionalAddress) === null || _c === void 0 ? void 0 : _c.phoneNumbers) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.number) {
        return dealer.additionalAddress.phoneNumbers[0].number;
    }
    if (!firstname && lastname && phoneNumber) {
        return phoneNumber;
    }
    const dealerPhone = (_g = (_f = dealer === null || dealer === void 0 ? void 0 : dealer.phoneNumbers) === null || _f === void 0 ? void 0 : _f.find((phone) => phone.type === 'phone')) === null || _g === void 0 ? void 0 : _g.number;
    if (dealerPhone) {
        return dealerPhone;
    }
    return undefined;
};
